import { adminServerInstance } from "../axios/instances";
import { 
    GET_BAG_ORDER_BY_BAG_NO,
    GET_BAG_ORDER_BY_BAG_NO_SUCCESS,
    GET_BAG_ORDER_BY_BAG_NO_FAIL,
    UPDATE_ORDERS_BY_BAG_NO,
    UPDATE_ORDERS_BY_BAG_NO_SUCCESS,
    UPDATE_ORDERS_BY_BAG_NO_FAIL,
    SAVE_BOX_SCAN_HISTORY,
    SAVE_BOX_SCAN_HISTORY_SUCCESS,
    SAVE_BOX_SCAN_HISTORY_FAIL,
    GET_BOX_SCAN_HISTORIES,
    GET_BOX_SCAN_HISTORIES_SUCCESS,
    GET_BOX_SCAN_HISTORIES_FAIL,
    GET_BOX_UPDATE_SUMMARY,
    GET_BOX_UPDATE_SUMMARY_SUCCESS,
    GET_BOX_UPDATE_SUMMARY_FAIL,
    FETCH_ORDER_INFO_BY_TRACKING_NUMBER,
    FETCH_ORDER_INFO_BY_TRACKING_NUMBER_SUCCESS,
    FETCH_ORDER_INFO_BY_TRACKING_NUMBER_FAIL,
    SCAN_TO_REMOVE,
    SCAN_TO_REMOVE_SUCCESS,
    SCAN_TO_REMOVE_FAIL,
    SCAN_WRONG_AREA,
    SCAN_WRONG_AREA_SUCCESS,
    SCAN_WRONG_AREA_FAIL,
    FETCH_ORDER_INFO_BY_UPS_ORDER_NUMBER,
    FETCH_ORDER_INFO_BY_UPS_ORDER_NUMBER_SUCCESS,
    FETCH_ORDER_INFO_BY_UPS_ORDER_NUMBER_FAIL,
    SCAN_REJECT,
    SCAN_REJECT_SUCCESS,
    SCAN_REJECT_FAIL,
    BATCH_CREATE_SECOND_DELIVERY,
    BATCH_CREATE_SECOND_DELIVERY_SUCCESS,
    BATCH_CREATE_SECOND_DELIVERY_FAIL,
    VALIDATE_BAG_NO,
    VALIDATE_BAG_NO_SUCCESS,
    VALIDATE_BAG_NO_FAIL,
    UPDATE_ORDERS_BY_TNOS,
    UPDATE_ORDERS_BY_TNOS_SUCCESS,
    UPDATE_ORDERS_BY_TNOS_FAIL,
    UPDATE_TRACKING_EXCEPTION_BY_TNO,
    UPDATE_TRACKING_EXCEPTION_BY_TNO_SUCCESS,
    UPDATE_TRACKING_EXCEPTION_BY_TNO_FAIL,
    BATCH_UPDATE_TO_GATEWAY_OUT,
    BATCH_UPDATE_TO_GATEWAY_OUT_SUCCESS,
    BATCH_UPDATE_TO_GATEWAY_OUT_FAIL,
    VIEW_UPDATE_ORDERS_BY_TNOS,
    VIEW_UPDATE_ORDERS_BY_TNOS_SUCCESS,
    VIEW_UPDATE_ORDERS_BY_TNOS_FAIL,
    GET_ORDERS_AND_CHECK_INPUT,
    GET_ORDERS_AND_CHECK_INPUT_SUCCESS,
    GET_ORDERS_AND_CHECK_INPUT_FAIL,
    SUB_BATCH_UPDATE_STATUS,
    SUB_BATCH_UPDATE_STATUS_SUCCESS,
    SUB_BATCH_UPDATE_STATUS_FAIL,
    UPDATE_NOTES_BY_TNOS,
    UPDATE_NOTES_BY_TNOS_SUCCESS,
    UPDATE_NOTES_BY_TNOS_FAIL,
} from './types';

/**
 * Allow at most 100 minute to process
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.batches - Batch no's
 * @param {string} params.state - New state
 * @param {string} params.warehouse - Warehouse id
 * @param {string} params.origin_state - Original State
 * @param {string} params.shipping_staff_id - Service no's
 */
export function subBatchUpdateStatus(params) {   
    return function(dispatch) {
        dispatch({type: SUB_BATCH_UPDATE_STATUS})
        return adminServerInstance.post(`/business/subbatchupdatestatus`, params, {
            timeout: 60000 * 100
        })
        .then(({data}) => {
            dispatch({
                type: SUB_BATCH_UPDATE_STATUS_SUCCESS,
                payload: data
            })
            return Promise.resolve(data);
        }).catch(error => {
            dispatch({
                type: SUB_BATCH_UPDATE_STATUS_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.tnos
 * @param {string} params.state
 * @param {string} params.sub_batch
 */
export function viewUpdateOrdersByTno(params) {
    return function(dispatch) {
        dispatch({type: VIEW_UPDATE_ORDERS_BY_TNOS})
        return adminServerInstance.post(`/business/viewupdateOrdersbytnos`, {
            ...params
        })
        .then(({data}) => {
            dispatch({
                type: VIEW_UPDATE_ORDERS_BY_TNOS_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: VIEW_UPDATE_ORDERS_BY_TNOS_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function batchUpdateToGatewayOut(params) {
    return function(dispatch) {
        dispatch({type: BATCH_UPDATE_TO_GATEWAY_OUT})
        return adminServerInstance.post(`/business/batchupdatetogatewayout`, {
            ...params
        })
        .then(({data}) => {
            dispatch({
                type: BATCH_UPDATE_TO_GATEWAY_OUT_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: BATCH_UPDATE_TO_GATEWAY_OUT_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function updateTrackingExceptionByTno(tno, exception) {
    return function(dispatch) {
        dispatch({type: UPDATE_TRACKING_EXCEPTION_BY_TNO})
        return adminServerInstance.post(`/business/updatetrackingexceptionbytno`, {
            tno: tno,
            exception: exception
        })
        .then(({data}) => {
            dispatch({
                type: UPDATE_TRACKING_EXCEPTION_BY_TNO_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: UPDATE_TRACKING_EXCEPTION_BY_TNO_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function updateOrdersByTnos(tnos, state, sub_batch, warehouse, exceptionId) {
    return function(dispatch) {
        dispatch({type: UPDATE_ORDERS_BY_TNOS})
        return adminServerInstance.post(`/business/updateOrdersbytnos`, {
            tnos: tnos,
            state: state,
            sub_batch: sub_batch,
            action_location: warehouse,
            exception: exceptionId
        })
        .then(({data}) => {
            dispatch({
                type: UPDATE_ORDERS_BY_TNOS_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: UPDATE_ORDERS_BY_TNOS_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function updateNotesByTnos(tnos, notes) {
    return function(dispatch) {
        dispatch({type: UPDATE_NOTES_BY_TNOS})
        return adminServerInstance.post(`/orders/updateordersmemo`, {
            tnos: tnos,
           order_notes: notes

        })
            .then(({data}) => {
                dispatch({
                    type: UPDATE_NOTES_BY_TNOS_SUCCESS,
                    payload: data.data
                })
                return Promise.resolve(data.data);
            }).catch(error => {
                dispatch({
                    type: UPDATE_NOTES_BY_TNOS_FAIL,
                    payload: error
                })
                return Promise.reject(error);
            });
    }
}

export function batchCreateSecondDelivery(sub_batch_no, warehouse, collector) {
    return function(dispatch) {
        dispatch({type: BATCH_CREATE_SECOND_DELIVERY})
        return adminServerInstance.post(`/business/batchcreateseconddelivery`, {
            sub_batch_no: sub_batch_no,
            warehouse: warehouse,
            origin_state: 213,
            collector: collector
        })
        .then(({data}) => {
            dispatch({
                type: BATCH_CREATE_SECOND_DELIVERY_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: BATCH_CREATE_SECOND_DELIVERY_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function scanReject(order_no) {
    return function(dispatch) {
        dispatch({type: SCAN_REJECT})
        return adminServerInstance.post(`/business/batchfixwronaddress`, {
            order_no: order_no,
            fix_type: 2
        })
        .then(({data}) => {
            dispatch({
                type: SCAN_REJECT_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: SCAN_REJECT_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function fetchOrderInfoByUPSOrderNumber(upsNumber) {
    return function(dispatch) {
        dispatch({type: FETCH_ORDER_INFO_BY_UPS_ORDER_NUMBER})
        return adminServerInstance.get(`/business/getupsorders?ups_no=${upsNumber}`)
        .then(({data}) => {
            dispatch({
                type: FETCH_ORDER_INFO_BY_UPS_ORDER_NUMBER_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: FETCH_ORDER_INFO_BY_UPS_ORDER_NUMBER_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function scanWrongArea(order_no, ups_no, warehouse, exception_id) {
    return function(dispatch) {
        dispatch({type: SCAN_WRONG_AREA})
        return adminServerInstance.post(`/business/batchfixwronaddress`, {
            order_no: order_no,
            fix_type: 0,
            ups_no: ups_no,
            scan_location: warehouse,
            exception: exception_id
        })
        .then(({data}) => {
            dispatch({
                type: SCAN_WRONG_AREA_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: SCAN_WRONG_AREA_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function scanToRemove(order_no, ups_no) {
    return function(dispatch) {
        dispatch({type: SCAN_TO_REMOVE})
        return adminServerInstance.post(`/business/batchfixwronaddress`, {
            order_no: order_no,
            fix_type: 1,
            ups_no: ups_no
        })
        .then(({data}) => {
            dispatch({
                type: SCAN_TO_REMOVE_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: SCAN_TO_REMOVE_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function fetchOrderInfoByBoxNumber(box_tracking_nos, excludeLg) {   
    return function(dispatch) {
        dispatch({type: GET_BAG_ORDER_BY_BAG_NO})
        return adminServerInstance.get(`/business/getbagordersbybagno?bag_nos=${box_tracking_nos}&exclude_LG=${excludeLg}`)
        .then(({data}) => {
            dispatch({
                type: GET_BAG_ORDER_BY_BAG_NO_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: GET_BAG_ORDER_BY_BAG_NO_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function updateStatusByBoxNumber(box_tracking_nos, state, sub_batch, warehouse, exception_id, isTransshipment, excludeLg) {   
    return function(dispatch) {
        dispatch({type: UPDATE_ORDERS_BY_BAG_NO})
        return adminServerInstance.post(`/business/updateordersbybagno`,{
            bag_nos: box_tracking_nos,
            state: state,
            sub_batch: sub_batch,
            scan_location: warehouse,
            exception: exception_id,
            transport: isTransshipment,
            exclude_LG: excludeLg
        })
        .then(({data}) => {
            dispatch({
                type: UPDATE_ORDERS_BY_BAG_NO_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: UPDATE_ORDERS_BY_BAG_NO_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function saveBoxScanHistory(box_tracking_nos, status, skid_no, sub_batch, excludeLg) {   
    return function(dispatch) {
        dispatch({type: SAVE_BOX_SCAN_HISTORY})
        return adminServerInstance.post(`/business/saveboxscanhistory`, {
            bag_nos: box_tracking_nos,
            state: status,
            skid_no: skid_no,
            sub_batch: sub_batch,
            exclude_LG: excludeLg
        })
        .then(({data}) => {
            dispatch({
                type: SAVE_BOX_SCAN_HISTORY_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: SAVE_BOX_SCAN_HISTORY_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getBoxScanHistories(box_tracking_nos, status, skid_no, excludeLg) {   
    return function(dispatch) {
        dispatch({type: GET_BOX_SCAN_HISTORIES})
        return adminServerInstance.get(`/business/getboxscanhistories?bag_no=${box_tracking_nos}&state=${status}&skid_no=${skid_no}&exclude_LG=${excludeLg}`)
        .then(({data}) => {
            dispatch({
                type: GET_BOX_SCAN_HISTORIES_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: GET_BOX_SCAN_HISTORIES_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function getBoxUpdateSummary(box_tracking_nos, status, excludeLg) {   
    return function(dispatch) {
        dispatch({type: GET_BOX_UPDATE_SUMMARY})
        return adminServerInstance.get(`/business/getbagupdatesummary?bag_nos=${box_tracking_nos}&state=${status}&exclude_LG=${excludeLg}`)
        .then(({data}) => {
            dispatch({
                type: GET_BOX_UPDATE_SUMMARY_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: GET_BOX_UPDATE_SUMMARY_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function fetchOrderInfoByTrackingNumber(tno) {   
    return function(dispatch) {
        dispatch({type: FETCH_ORDER_INFO_BY_TRACKING_NUMBER})
        return adminServerInstance.get(`/business/getbagnobytno?tno=${tno}`)
        .then(({data}) => {
            dispatch({
                type: FETCH_ORDER_INFO_BY_TRACKING_NUMBER_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: FETCH_ORDER_INFO_BY_TRACKING_NUMBER_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

export function validateBagNo(box_tracking_number_check, subBatch, state) {   
    return function(dispatch) {
        dispatch({type: VALIDATE_BAG_NO})
        return adminServerInstance.post(`/business/validatebagno`,{
            bag_no: box_tracking_number_check,
            sub_batch: subBatch,
            state: state
        })
        .then(({data}) => {
            dispatch({
                type: VALIDATE_BAG_NO_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: VALIDATE_BAG_NO_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}

/**
 * 
 * @param {Object} params - combined object to send for server processing
 * @param {string} params.partner_id - Partner id
 * @param {string} params.state - States
 * @param {string} params.express_type - Express type
 * @param {string} params.bag_nos - Bag no's
 * @param {string} params.references - References
 * @param {string} params.sub_references - Sub references
 * @param {string} params.is_LG
 * @param {string} params.carrier_type - Carrier type
 */
export function getOrdersAndCheckInput(params){
    return function(dispatch) {
        dispatch({type: GET_ORDERS_AND_CHECK_INPUT})
        return adminServerInstance.get(`/business/getordersandcheckinput`, {
            params: params
        })
        .then(({data}) => {
            dispatch({
                type: GET_ORDERS_AND_CHECK_INPUT_SUCCESS,
                payload: data.data
            })
            return Promise.resolve(data.data);
        }).catch(error => {
            dispatch({
                type: GET_ORDERS_AND_CHECK_INPUT_FAIL,
                payload: error
            })
            return Promise.reject(error);
        });
    }
}
